export default __webpack_public_path__ + "static/media/red-info.52db6e55.svg";